import { Injectable } from '@angular/core';
import { FirestoreSubCollectionRepository } from '@core/services';
import type { ClientIntakeForm } from '@models/client-intake';

export interface ClientIntakeFormsPathParams {
	businessId: string;
	matterId: string;
	clientIntakeFormId: string;
}

@Injectable({
	providedIn: 'root',
})
export class FBClientIntakeFormsRepo extends FirestoreSubCollectionRepository<
	ClientIntakeForm,
	Pick<ClientIntakeFormsPathParams, 'businessId' | 'matterId'>
> {
	protected getCollectionPath(
		pathParams: Pick<ClientIntakeFormsPathParams, 'businessId' | 'matterId'>,
	): string {
		return `businesses/${pathParams.businessId}/matters/${pathParams.matterId}/clientIntakeForms`;
	}
}
